import { render, staticRenderFns } from "./About.html?vue&type=template&id=d1138f74&scoped=true&external"
import script from "./About.ts?vue&type=script&lang=ts&external"
export * from "./About.ts?vue&type=script&lang=ts&external"
import style0 from "./About.scss?vue&type=style&index=0&id=d1138f74&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1138f74",
  null
  
)

export default component.exports